export default __webpack_public_path__ + "static/media/PhotoIcon.334fe7f2.svg";